import { Box, Grid, Modal, Stack, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsTypography, WsTypoVariants, WsButton, WsColors, Item } from 'wisestep-base';

import Checkmark from '../../../../components/skuModal/check.png';

const ModalBox = styled(Box)({
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});
interface ModalForRedirectionType {
  modalState: boolean;
  onClose(): void;
  message?: string;
  leftButtonText?: string;
  rightButtonText?: string;
  rightButtonAction?: () => void;
}

const ModalForRedirection = ({
  modalState,
  onClose,
  message = 'You have successfully configured your IMAP account.',
  leftButtonText: successButtonText = 'Done',
  rightButtonText = 'View Inbox',
  rightButtonAction,
}: ModalForRedirectionType) => {
  const navigate = useNavigate();
  const navigateToEmail = () => navigate('/email-settings/logs/inbox/');

  const handleOnClick = () => (rightButtonAction ? rightButtonAction() : navigateToEmail());

  return (
    <Modal open={modalState} onClose={onClose}>
      <ModalBox borderRadius={1.5} bgcolor={WsColors.White} p={1} height={250} width={600}>
        <Grid justifyContent="center" container>
          <Grid direction="row" item>
            <Item>
              <Stack direction="column" alignItems="center" justifyContent="space-between">
                <img src={Checkmark} alt="CareerBuilder" width="30" height="30" />
              </Stack>
            </Item>
            <Item>
              <WsTypography variant={WsTypoVariants.TITLE}>{message} </WsTypography>
            </Item>
          </Grid>
        </Grid>
        <Stack marginTop={2} spacing={2} justifyContent="flex-end" direction="row">
          <WsButton size="medium" variant="outlined" onClick={onClose}>
            {successButtonText}
          </WsButton>
          <WsButton size="medium" variant="contained" onClick={handleOnClick}>
            {rightButtonText}
          </WsButton>
        </Stack>
      </ModalBox>
    </Modal>
  );
};
export default ModalForRedirection;
